module.exports = __webpack_public_path__ + "img/AusGEO.48847ec1fc949040ae1e3fd16202522e.jpg";